import LabelInfo from './LabelInfo';

export default LabelInfo;
